const EventClassification = {
    A:'Actual',
    N:'Not an Actual',
    F:'False Alarm',
    T:'Test Event',
    null:'Not Classified'  
}

export default EventClassification;